import React from 'react'
import { MatchElementsCardProps } from '@sport1/types/web'
import { WidgetTrackingIdentifier } from '@sport1/bets-service-client'
import HorizontalMatchElementsCards from '@/components/MatchElementsCard/Horizontal'
import VerticalMatchElementsCards from '@/components/MatchElementsCard/Vertical'
import { OddsDisclaimerContextProvider } from '@/utils/oddsDisclaimer/OddsDisclaimerProvider'

type MatchElementsCard = Omit<MatchElementsCardProps, 'type'> & {
    trackingInteractionLabel: string
    trackingCreation?: WidgetTrackingIdentifier
}

const MatchElementsCard = ({ isHorizontal, ...otherProps }: MatchElementsCard) => (
    <OddsDisclaimerContextProvider>
        {isHorizontal ? (
            <HorizontalMatchElementsCards {...otherProps} />
        ) : (
            <VerticalMatchElementsCards {...otherProps} />
        )}
    </OddsDisclaimerContextProvider>
)

export default MatchElementsCard
